import { createSelector } from 'reselect';

import { BOOK_SUPPORT_ENABLED_FEATURE_FLAG_NAME, BOOKS_DISABLED_FOR_LIBRARIES } from '@pressreader/catalog-types';
import { selectGetConfigValue } from '@pressreader/config';

type BooksGlobalConfig = {
    enabled: boolean;
};

export const selectBooksGlobalConfig = createSelector(selectGetConfigValue, (getConfigValue): BooksGlobalConfig => {
    const supportEnabled = getConfigValue<boolean>(BOOK_SUPPORT_ENABLED_FEATURE_FLAG_NAME, false);
    const disabledForLibrary = getConfigValue<boolean>(BOOKS_DISABLED_FOR_LIBRARIES, false);
    return {
        enabled: supportEnabled && !disabledForLibrary,
    };
});

const BOOKS_SAMPLES_NO_PRODUCTS = 'app.views.books.samples.no_products.enabled';

/** Book samples may be opened even when there are no purchasable products for the book. */
export const selectBookSamplesNoProductsEnabled = createSelector(selectGetConfigValue, (getConfigValue): boolean => {
    return getConfigValue<boolean>(BOOKS_SAMPLES_NO_PRODUCTS, false);
});
